// extracted by mini-css-extract-plugin
module.exports = {"stats-card":"StatsCard_stats-card__1H1DV","icon":"StatsCard_icon__7mn_z"};